const HEADER = "Dennis S. Arnon";

const NAVBAR_DATA = [
  { id: 1, url: "/", label: "Home" },
  { id: 2, url: "#services", label: "   " },
  { id: 3, url: "#about-us", label: "    " },
  { id: 4, url: "#testimonials", label: "    " },
  { id: 5, url: "#footer", label: "Contact information" }
];

const BANNER_DATA = {
  HEADING: "Dennis S. Arnon - Selected Publications in Computer Mathematics Research",
  DESCRIPTION:
    "Dennis S. Arnon: Algorithms and Software Solutions Development, Critical Situations Resolution Management, Tools and Techniques for Personal Data Sovereignty",
  TUTORIAL_URL:
    "https://www.instagram.com/one_digital_life/",
  WATCH_TUTORIAL: "Instagram"
};

const SERVICE_DATA = {
  HEADING: "Landscape and Urban: Scenes, Patterns, Abstractions",
  ALL_SERVICES: "Additional Works",
  SERVICE_LIST: [
    {
      LABEL: "Landscapes",
      DESCRIPTION:
        "The imagination takes flight.",
      URL: "images/provesendeAbstract.jpg"
    },
    {
      LABEL: "Urban Scenes",
      DESCRIPTION:
        "There is visual interest in the city streets.",
      URL: "images/cityBuildings.jpg"
    },
    {
      LABEL: "Abstract Scenes",
      DESCRIPTION:
        "What is in front of our eyes is only the beginning.",
      URL: "images/diebenkorn_not_my_colors.jpg"
    }
  ]
};

const ABOUT_DATA = {
  HEADING: "Geometric: Patterns, Abstract, Scenes",
  TITLE: "Bringing Geometry into Everyday Life",
  IMAGE_URL: "images/geometric_crowd.jpg",
  WHY_CHOOSE_US_LIST: [
    "The first step is geometric rendering, i.e. visualization, of what the mathematical equations define.",
    "As we are human, we are free to let our imaginations explore these new elements of our vocabulary."
  ]
};
const TESTIMONIAL_DATA = {
  HEADING: "Cookery and Food are Life's pleasures.",
  TESTIMONIAL_LIST: [
    {
      DESCRIPTION:
        "The pot we use every day is worthy of our appreciation.",
      IMAGE_URL: "images/coffeePot.JPG",
      NAME: "Stovetop coffeepot",
      DESIGNATION: "Coffee par excellence"
    },
    {
      DESCRIPTION:
        "Bright colors and sweet tastes enhance our lives.",
      IMAGE_URL: "images/macaroons.jpg",
      NAME: "Macaroons",
      DESIGNATION: "Something special on the plate."
    }
  ]
};

const SOCIAL_DATA = {
  HEADING: "Connect with me on social media (for now these all just go to my Instagram)",
  IMAGES_LIST: [
    "images/facebook-icon.png",
    "images/instagram-icon.png",
    "images/whatsapp-icon.png",
    "images/twitter-icon.png",
    "images/linkedin-icon.png",
    "images/snapchat-icon.png"
  ]
};

const FOOTER_DATA = {
  DESCRIPTION:
    "Acknowledgement: Thanks to Nikhil Karkra, Florian Raffl, and many others who graciously share their Svelte expertise via articles videos and GitHub.  This website is made with Svelte.",
  CONTACT_DETAILS: {
    HEADING: "Contact me:",
    ADDRESS: "San Francisco, California, USA",
    MOBILE: "(Forthcoming)",
    EMAIL: "(Forthcoming)"
  },
  SUBSCRIBE_NEWSLETTER: "(Forthcoming) Subscribe to my mailing list:",
  SUBSCRIBE: "Subscribe"
};

const MOCK_DATA = {
  HEADER,
  NAVBAR_DATA,
  BANNER_DATA,
  SERVICE_DATA,
  ABOUT_DATA,
  TESTIMONIAL_DATA,
  SOCIAL_DATA,
  FOOTER_DATA
};
export default MOCK_DATA;
